import React, { useEffect, useRef } from 'react';
import { useGlobalState } from '../GlobalState';

function Secure3DChallengeForm({
  acs_url,
  creq,
  secure_3d_session_data,
  onPaymentSuccess,
  onPaymentFailure,
}) {
  const secure3DFormRef = useRef();
  const [, setPaymentError] = useGlobalState('paymentError');
  const [, setPaymentSuccessRedirect] = useGlobalState('paymentSuccessRedirect');

  useEffect(() => {
    if (acs_url && creq && secure3DFormRef?.current) {
      secure3DFormRef.current.submit();
    }
  }, [acs_url, creq]);

  useEffect(() => {
    const on3DSComplete = (event) => {
      if (
        event?.origin !== process.env.REACT_APP_API_ORIGIN ||
        event?.data?.type !== '3dsCallback'
      ) {
        return;
      } else if (event?.data?.type !== '3dsCallback') {
        // Incorrect origin
        setPaymentError(
          'There was an issue processing the result from the server. Please contact us on 0208 194 9396 with the following information: ' +
            JSON.stringify(event?.data)
        );
        onPaymentFailure();
      }
      if (event.data?.status === 200) {
        setPaymentSuccessRedirect(event?.data?.redirect)
        onPaymentSuccess();
      } else {
        setPaymentError(event.data?.detail);
        onPaymentFailure();
      }
    };
    window.addEventListener('message', on3DSComplete);
    return () => window.removeEventListener('message', on3DSComplete);
  }, [onPaymentFailure, onPaymentSuccess, setPaymentError]);

  return (
    <>
      <form
        ref={secure3DFormRef}
        action={acs_url}
        method='post'
        target='3Diframe'
      >
        <input type='hidden' name='creq' value={creq} />
        <input
          type='hidden'
          name='threeDSSessionData'
          value={secure_3d_session_data}
        />
      </form>
      <iframe
        name={'3Diframe'}
        title={'Secure 3D Authentication Window'}
        width={'100%'}
        height={'400px'}
      />
    </>
  );
}

export default Secure3DChallengeForm;
